<button class="btn {{ class }} ">
  <span *ngIf="iconLeft != ''">Left</span>
  {{ text }}
  <span *ngIf="iconRight != ''">Right</span>
</button>
